import { getLanguageName } from '@core/utils';

/**
 * Supported language codes for content search filter dropdowns.
 * This is intentionally a subset — the full map lives in @core/utils/languageHelpers.
 */
const FILTER_LANGUAGE_CODES = ['ar', 'de', 'en', 'es', 'fr', 'hi', 'it', 'pt', 'ru'] as const;

/**
 * Get the display name for a language code.
 * Delegates to the shared core language map for human-readable names.
 */
export function getLanguageDisplayName(code: string): string {
  return getLanguageName(code);
}

/**
 * Get all available language options for dropdowns
 * @returns Array of language options with value and label
 */
export function getLanguageOptions() {
  return [{ value: 'all', label: 'All' }, ...FILTER_LANGUAGE_CODES.map(code => ({ value: code, label: getLanguageName(code) }))];
}

/**
 * Get all supported language codes
 * @returns Array of language codes
 */
export function getSupportedLanguageCodes(): string[] {
  return [...FILTER_LANGUAGE_CODES];
}
